import { useState } from 'react';
import { Carousel } from 'antd';
import { useNavigate } from 'react-router-dom';
import carousel2 from '../images/Haleon/carousel2_sg.png';
import carousel4 from '../images/Haleon/carousel4_sg.png';
import carousel5 from '../images/Haleon/carousel5_sg.png';
import carouselGuardian from '../images/Haleon/carouselGuardian_sg.png';
import carouselWelcome from '../images/Haleon/carousel_welcome.png';

const Sg_carousel = ({ onOpenGuardianPopup }) => {
	const [currentSlide, setCurrentSlide] = useState(0);
	const navigate = useNavigate();
	const images = [
		// { img: carousel1, pageName: '/badges' },
		// { img: carousel3, pageName: 'https://qrcodes.pro/Gv2my8' },
		{ img: carousel4, pageName: 'https://wa.link/7ybp4t' }, 
		{ img: carousel5, pageName: 'https://wa.link/7ybp4t' }, 
		{ img: carousel2, pageName: null },
		{ img: carouselGuardian, pageName: "openPopupGuardian" },
		{ img: carouselWelcome, pageName: null },    // must at last
	];

	const handleImageClick = (pageName) => {
		if (pageName) {
			if (pageName.startsWith('http')) {
				window.open(pageName, '_blank');
			} else {
				if(pageName === "openPopupGuardian"){
					onOpenGuardianPopup();
				}
				else {
					navigate(pageName);
				}
			}
		}
	};

	const onChange = (current) => {
		setCurrentSlide(current);
	};

	const isGuardianExpired = new Date().getTime() > new Date('2025-8-31').getTime();

	return (
		<div>
				<Carousel
					dots={true}
					afterChange={onChange}
					className="sg-carousel-container"
					dotPosition='bottom'
					// autoplay={true}
					// autoplaySpeed={5000}
				>
					{images.map((image, index) => {
						if(image.img === carouselGuardian && isGuardianExpired) return	
						
						return <div key={index} onClick={() => handleImageClick(image.pageName)}>
									<img
										src={image.img}
										alt={`carousel`}
										style={{ objectFit: 'contain', width:'100%', height:'100%', borderRadius: '16px', padding:'8px'}}
									/>
								</div>
							} 
					)}
				</Carousel>
		</div>
	);
};

export default Sg_carousel;
